<!-- 返回顶部 -->
<style scoped>
.backToTop {
    position: fixed;
    bottom: 180px;
    right: 10px;
    display: -webkit-flex;
    display: flex;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: rgba(18,145,249,.8);
    color: #ffffff;
    justify-content: center;
    -webkit-justify-content: center;
    align-items: center;
    -webkit-align-items: center;
    cursor: pointer;
    z-index: 3;
}
i {
    display: block;
    width: 20px;
    height: 20px;
    margin: 0 auto;
    background-image: url(../assets/images/leftNavIconSelection.png);
    background-size: 100% 100%;
    transform: rotate(-90deg);
    -webkit-transform: rotate(-90deg);
}
p {
    margin-top: 5px;
    text-align: center;
    color: #ffffff;
    font-size: 14px;
}
</style>
<template>
    <div class="backToTop" @click="backtop" v-show="scrollTop >= 100">
        <div>
            <i class="leftNavIconSelection"></i>
            <p>返回顶部</p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'backToTop',
    data() {
        return {
            scrollTop: 0
        }
    },
    methods: {
        // 显示回到顶部按钮
        showbtn(){
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            this.scrollTop = scrollTop;
        },
        backtop(){
            var timer = setInterval(function(){
                let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                let ispeed = Math.floor(-osTop / 5);
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                if(osTop <= 0){
                    clearInterval(timer);
                }
            },10)
        }
    },
    mounted() {
        window.addEventListener("scroll",this.showbtn,true);
    }
}
</script>


// WEBPACK FOOTER //
// src/components/backToTop.vue